import classes from "./Layout.module.css";


export default function Layout({children,id}) {
    return (
        <div className={classes.layout} id={id}>
            {children}
        </div>
    )
}